import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PulseLogo } from "./Header";
import { Instagram, Youtube, Mail, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative mt-20" data-testid="site-footer">
      {/* All-black main footer area */}
      <div className="bg-[#08080A]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-10">
          {/* Top section */}
          <div className="grid md:grid-cols-4 gap-12 pb-16">
            <div className="md:col-span-2">
              <div className="flex items-center gap-3 mb-4">
                <PulseLogo size={36} />
                <div className="font-display font-bold text-lg tracking-tight">PULSE MEDIA</div>
              </div>
              <p className="text-zinc-400 max-w-md text-sm leading-relaxed">
                The business and informational arm of Pulse Portal — a four-branch record label spanning music, film, and technology.
              </p>
              <div className="flex gap-3 mt-6">
                <a href="https://www.instagram.com/pulsemedia.vip" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="glass-btn ghost p-3" aria-label="Instagram"><Instagram size={16} /></a>
                <a href="https://www.youtube.com/@PulseVIP" target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" className="glass-btn ghost p-3" aria-label="YouTube"><Youtube size={16} /></a>
                <a href="https://www.facebook.com/pulsellc?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="glass-btn ghost p-3" aria-label="Facebook"><Facebook size={16} /></a>
                <a href="mailto:contact@pulsemedia.vip" data-testid="footer-email" className="glass-btn ghost p-3" aria-label="Email"><Mail size={16} /></a>
              </div>
            </div>

            <div>
              <div className="label-mono mb-4">Network</div>
              <ul className="space-y-2 text-sm text-zinc-400">
                <li><a href="/artists" className="hover:text-white">Artist Roster</a></li>
                <li><a href="/videos" className="hover:text-white">Video Production</a></li>
                <li><a href="/distribution" className="hover:text-white">Distribution</a></li>
                <li><a href="http://www.pulseportal.tv" className="hover:text-white" target="_blank" rel="noopener noreferrer">Portal TV</a></li>
              </ul>
            </div>

            <div>
              <div className="label-mono mb-4">Company</div>
              <ul className="space-y-2 text-sm text-zinc-400">
                <li><a href="/about" className="hover:text-white">About</a></li>
                <li><a href="mailto:contact@pulsemedia.vip" className="hover:text-white">Contact</a></li>
                <li><a href="/login" className="hover:text-white">Admin</a></li>
              </ul>
            </div>
          </div>

          {/* Affiliate logos — fully on the black area */}
          <div className="pt-10 pb-16 border-t border-white/10">
            <div className="label-mono mb-6 text-center text-zinc-500">/ In partnership with</div>
            <div className="flex items-center justify-center">
              <img
                src="/assets/affiliates.png"
                alt="Affiliates: Pulse Media, Origin Audio, SE Empire, Virgin"
                className="max-w-3xl w-full h-auto"
                data-testid="affiliates-logos"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Smooth black-to-white transition strip */}
      <div className="h-24 footer-gradient-bottom" />

      {/* Disclaimer — fully on white */}
      <div className="bg-white px-6 lg:px-10 py-20">
        <div className="text-center text-black/70 text-[11px] font-mono tracking-wider leading-relaxed max-w-3xl mx-auto">
          <p>© 2026 PULSE MEDIA — ALL RIGHTS RESERVED.</p>
          <p className="mt-3">DISTRIBUTION SERVICES PROVIDED THROUGH ORIGIN AUDIO, SE EMPIRE DISTRIBUTION AND VIRGIN MUSIC, A DIVISION OF UNIVERSAL.</p>
          <p className="mt-2">PULSE MEDIA IS THE BUSINESS ARM OF PULSEPORTAL.TV.</p>
          <p className="mt-2">ALL ARTIST AGREEMENTS ARE SUBJECT TO INDIVIDUAL TERMS.</p>
        </div>
      </div>
    </footer>
  );
}
